export const GET_POKEMON_BY_ID = 'GET_POKEMON_BY_ID';
export const GET_POKEMONS_BY_RANGE_OF_ID = 'GET_POKEMONS_BY_RANGE_OF_ID';
export const UPDATE_START_INDEX = 'UPDATE_START_INDEX';
export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
